import { Box, SxProps, Theme } from '@mui/material'
import { green, grey, red, yellow } from '@mui/material/colors'
import { DateTime } from 'luxon'
import { TimeString } from '../../types/models'
import { now } from '../../utils/time'

export interface AgeLightProps {
  since?: TimeString
  sx?: SxProps<Theme>
}

const OLD = 24 * 60
const RECENT = 15

/**
 * Display an icon for an appliance type.
 */
export const AgeLight = (props: AgeLightProps): JSX.Element => {

  const { since } = props
  const sx = {
    ...props.sx
  }

  let color
  if (!since) {
    color = grey[700]
  } else {
    const age = now().toMillis() - DateTime.fromISO(`${since}`).toMillis()
    const minutes = age / (60 * 1000)
    if (minutes < RECENT) {
      color = green[700]
    } else if (minutes < OLD) {
      color = yellow[400]
    } else {
      color = red[700]
    }
  }

  return (
    <Box sx={{
      mx: 'auto',
      display: 'inline-block',
      backgroundColor: color,
      width: '0.5rem',
      height: '0.5rem',
      borderRadius: '3px',
      borderleft: '1px solid rgba(255,255,255,0.3)',
      borderTop: '1px solid rgba(255,255,255,0.3)',
      borderBottom: '1px solid rgba(0,0,0,0.3)',
      borderRight: '1px solid rgba(0,0,0,0.3)',
      ...sx
    }}/>
  )
}
